export default __webpack_public_path__ + "static/Calibre-LightItalic-6dbedbbaf29da86f5f5b2b7406ade943.woff";